import * as Yup from 'yup';

export interface ResetPasswordType extends Record<string, unknown> {
    password: string;
    confirmPassword: string;
}

/**
 * The same numbers the server enforces - PasswordValidator in data-service.
 *
 * This said six while the server demanded eight, so the form accepted a password the server then
 * refused, and the refusal arrived as a toast with no field marked. That is the shape of the bug an
 * employee spent days on: everything looked accepted right up until nothing happened.
 */
export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 128;

export const resetPasswordSchema = Yup.object().shape({
    password: Yup.string()
        .min(PASSWORD_MIN_LENGTH)
        .max(PASSWORD_MAX_LENGTH)
        // Any letter, not only A-Z, and any digit - the same test the server makes with
        // Character.isLetter / isDigit, so an accented password is accepted by both.
        .matches(/\p{L}/u, 'schemaPasswordNeedsLetter')
        .matches(/\p{Nd}/u, 'schemaPasswordNeedsDigit')
        .required('schemaRequiredPassword'),
    confirmPassword: Yup.string().oneOf([Yup.ref('password'), null], 'schemaMatchPassword'),
});
